@let workerConfig = config();
@let item = postItem();
@if (workerConfig) {
  <div class="relative group @container" (click)="onAction()">
    <div
      class="rounded-2xl h-auto min-h-[4.25rem] @post:h-19 gap-2 p-3 @post:p-2.5 items-center bg-white cursor-pointer shadow-sm shadow-black/20 border-l-4 duration-300 transition grid grid-cols-[auto_1fr_30px] @post:grid-cols-[30px_1fr_auto_30px] group-hover:bg-gray-100"
      [ngClass]="workerConfig.color"
    >
      <div class="row-start-1 @post:row-auto @post:col-auto col-start-1 flex items-center justify-center">
        @if (clicked()) {
          <app-skeleton [showLabel]="false" baseStyle="bg-none"></app-skeleton>
        } @else {
          <svg-icon
            class="flex items-center justify-center w-9 h-9 rounded-xl p-1.5"
            [ngClass]="workerConfig.iconStyle"
            [src]="workerConfig.icon | icon"
          ></svg-icon>
        }
      </div>
      <div
        class="flex flex-col justify-center w-full gap-1 overflow-hidden h-full row-start-1 col-start-2 @post:row-auto @post:col-auto"
      >
        <span class="font-medium text-md max-w-[90%] truncate items-center gap-4 flex">
          <span class="truncate font-medium text-md">
            {{ item.title }}
          </span>
          <span class="border rounded-full px-2" [ngClass]="workerConfig.labelStyle">
            {{ workerConfig.singular | translate }}
          </span>
        </span>
        <ng-container
          class="truncate"
          [ngComponentOutlet]="workerConfig.subtitle"
          [ngComponentOutletInputs]="{ item }"
        ></ng-container>
      </div>
      <div
        class="flex items-center gap-4 justify-end mt-1 row-start-2 col-start-1 col-span-2 @post:row-auto @post:col-auto"
      >
        @if (workerConfig.extra) {
          <div (click)="$event.stopPropagation()">
            <ng-container
              [ngComponentOutlet]="workerConfig.extra"
              [ngComponentOutletInputs]="{ item, loaderFn, actionFn: onAction }"
            ></ng-container>
          </div>
        }
        <span class="whitespace-nowrap text-title" app-tooltip [tooltip]="item.date | dateTranslate: 'fullDate'">
          {{ item.date | date: (isPreviousYear(item.date) ? 'dd/MM/yyyy' : 'dd/MM') }}
        </span>
      </div>
    </div>
    @if (workerConfig.options(item) | async; as options) {
      @if (options | noEmpty) {
        <button
          type="button"
          class="absolute right-2.5 top-1/2 -translate-y-1/2 h-10 w-10 pl-px flex items-center justify-center rounded-full hover:inset-shadow-sm hover:inset-shadow-black/20 cursor-pointer transition"
          (click)="onToogle($event)"
        >
          <svg-icon
            class="items-center flex text-theme justify-center w-1.5 h-4"
            [src]="'icon-three-dots' | icon"
          ></svg-icon>
          <div
            class="absolute gap-2 -right-1 transition flex items-center rounded-full bg-white shadow-sm shadow-black/20 p-1"
            [ngClass]="{ hidden: !showMenu() }"
          >
            @for (option of options; track $index) {
              @if (option.action) {
                <button
                  app-tooltip
                  [tooltip]="option.title | translate"
                  (click)="onOption(option)"
                  type="button"
                  class="relative rounded-full hover:bg-white hover:inset-shadow-sm hover:inset-shadow-black/20 cursor-pointer p-[4px] m-[2px] w-[26px] h-[26px] transition"
                  [ngClass]="option.class || 'text-[#432D85]'"
                >
                  @if (option.icon) {
                    <svg-icon class="flex justify-center w-full h-full" [src]="option.icon | icon"></svg-icon>
                  }
                </button>
              } @else {
                <a
                  app-tooltip
                  [tooltip]="option.title | translate"
                  [routerLink]="option.link"
                  class="relative rounded-full hover:bg-white hover:inset-shadow-sm hover:inset-shadow-black/20 cursor-pointer p-[4px] m-[2px] w-[26px] h-[26px] transition"
                  [ngClass]="option.class || 'text-[#432D85]'"
                >
                  @if (option.icon) {
                    <svg-icon class="flex justify-center w-full h-full" [src]="option.icon | icon"></svg-icon>
                  }
                </a>
              }
            }
            <button
              type="button"
              class="relative pl-px rounded-full flex items-center justify-center bg-white inset-shadow-sm inset-shadow-black/20 cursor-pointer h-10 w-10 transition"
            >
              <svg-icon
                class="items-center flex text-theme justify-center w-1.5 h-4"
                [src]="'icon-three-dots' | icon"
              ></svg-icon>
            </button>
          </div>
        </button>
      }
    }
  </div>
}
